export const FEATURES = {
  NANTONG: process.env.REACT_APP_PLATFORM_SERVER !== 'NANTONG',
};